<script lang="ts">
  import moment from 'moment';
  import { onDestroy, onMount } from 'svelte';
  import {
    Chart as ChartJS,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    LineController,
    BarController,
  } from 'chart.js';
  import Table from '../Table.svelte';
  import { Chart } from 'svelte-chartjs';
  import zoomPlugin from 'chartjs-plugin-zoom';
  import DateRange from '../common/DateRange.svelte';
  import { options } from '../../configs/BarOptions';
  import GameSelect from '../common/GameSelect.svelte';
  import { squezzeBranches } from '../../utils/branches';
  import { requestsParams } from '../../configs/Requests';
  import CountriesSelect from '../common/CountriesSelect.svelte';
  import loader from 'src/components/cabinet/#assets/loader.svg';
  import { processChartDataset, resetChart } from '../../utils/common';
  import { getTransactionsAnalytics } from 'src/components/cabinet/#services/transactionsAnalytics';

  let chart, table;

  let creator = 'all';
  let country = null;
  let userId = null;
  
  let labels = [];
  let datasets = [];

  let data = { labels, datasets };

  let startDate = 'startDate'
  let endDate = 'endDate'

  const minDate = '2022-07-12';
  const maxDate = moment().format('YYYY-MM-DD');

  ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    zoomPlugin,
  );

  function refresh() {
    resetChart(chart, labels, datasets);

    const requestData = requestsParams.spending({
      creator: creator !== 'all' ? creator : undefined,
      country: country?.value,
      userId: userId || undefined,
      startDate: startDate && startDate !== 'startDate' ? startDate : minDate,
      endDate: endDate && endDate !== 'endDate' ? endDate : maxDate,
    });

    getTransactionsAnalytics.send({ data: requestData });
  }

  getTransactionsAnalytics.subscribe((value) => {
    if (value.hasValue && !value.error && !value.loading) {
      processChartDataset(value.value, labels, datasets);

      try {
        table = {
          'Units, LIS': value.value.branches[0]?.values,
          'Upgrades, LIS': value.value.branches[1]?.values,
          'Airdrop, LIS': value.value.branches[2]?.values,
          'x3, LIS': value.value.branches[3]?.values,
          'Speed boost, LIS': value.value.branches[4]?.values,
          'Science, LIS': value.value.branches[5]?.values,
          'Total, LIS': squezzeBranches([value.value.branches[0]?.values, value.value.branches[1]?.values, value.value.branches[2]?.values, value.value.branches[3]?.values, value.value.branches[4]?.values, value.value.branches[5]?.values])
        }
        console.log('=====', table)
      } catch (e) {}
    }
  });

  onDestroy(() => {
    resetChart(chart);
    getTransactionsAnalytics.reset();
  });

  onMount(() => {
    refresh();
  });
</script>

<div class="buttons">
  <DateRange bind:startDate={startDate} bind:endDate={endDate} {minDate} {maxDate} refreshCallback={() => refresh()} />
</div>

<hr>

<div class="buttons">
  <div class="pc-line">
    <span class="date-label">Game</span>
    <GameSelect bind:creator={creator} refreshCallback={() => refresh()} />
  </div>
  <div class="pc-line">
    <span class="date-label">User</span>
    <input type="text" class="form-control" bind:value={userId} placeholder="Input UserID" on:input={refresh}>
  </div>
  <div class="pc-line">
    <CountriesSelect bind:country={country} refreshCallback={() => refresh()} />
  </div>
</div>
<hr>
<div class="buttons">
  <div class="pc-line">
    <button class="btn btn-primary btn-filter" on:click={refresh}>Refresh</button>
  </div>
</div>
<p class="description">Summarized purchases and upgrades of units in LIS in different games.</p>
<div class="graphic">
  {#if $getTransactionsAnalytics.error}
    Something went wrong. Try refreshing the page.
  {:else if $getTransactionsAnalytics.loading}
    <div class="graphic-loading">
      <img src="{loader}" alt="">
    </div>
  {:else if $getTransactionsAnalytics.value}
    <Chart bind:this={chart} type="bar" {data} width={500} height={270} {options} />
    <Table branches={table} isTableHidden={false} percentsInTotal={true} />
  {/if}
</div>